import Line from './Line.js'

export default function OrderLines({order, isExpanded}) {
  const count = isExpanded ? order.lines.length : 0
  const lines = order.lines.slice(0, count)

  return (
    <ul className="list--line">
      {lines.map((line) => (
        <Line key={line.link} orderNumber={order.order_number} line={line} />
      ))}
    </ul>
  )
}
